var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7794_55726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 29.3333H23.9999V26.6666C23.9999 25.6057 23.5785 24.5883 22.8283 23.8382C22.0782 23.088 21.0608 22.6666 19.9999 22.6666H11.9999C10.9391 22.6666 9.92164 23.088 9.17149 23.8382C8.42135 24.5883 7.99992 25.6057 7.99992 26.6666V29.3333H5.33325V26.6666C5.33325 24.8985 6.03563 23.2028 7.28587 21.9525C8.53612 20.7023 10.2318 19.9999 11.9999 19.9999H19.9999C21.768 19.9999 23.4637 20.7023 24.714 21.9525C25.9642 23.2028 26.6666 24.8985 26.6666 26.6666V29.3333ZM15.9999 17.3333C14.9493 17.3333 13.9091 17.1263 12.9385 16.7243C11.9678 16.3223 11.0859 15.733 10.3431 14.9901C9.60019 14.2472 9.01092 13.3653 8.60888 12.3947C8.20684 11.4241 7.99992 10.3838 7.99992 9.33325C7.99992 8.28268 8.20684 7.24239 8.60888 6.27178C9.01092 5.30118 9.60019 4.41927 10.3431 3.6764C11.0859 2.93353 11.9678 2.34425 12.9385 1.94222C13.9091 1.54018 14.9493 1.33325 15.9999 1.33325C18.1216 1.33325 20.1565 2.17611 21.6568 3.6764C23.1571 5.17669 23.9999 7.21152 23.9999 9.33325C23.9999 11.455 23.1571 13.4898 21.6568 14.9901C20.1565 16.4904 18.1216 17.3333 15.9999 17.3333ZM15.9999 14.6666C17.4144 14.6666 18.771 14.1047 19.7712 13.1045C20.7713 12.1043 21.3333 10.7477 21.3333 9.33325C21.3333 7.91876 20.7713 6.56221 19.7712 5.56202C18.771 4.56182 17.4144 3.99992 15.9999 3.99992C14.5854 3.99992 13.2289 4.56182 12.2287 5.56202C11.2285 6.56221 10.6666 7.91876 10.6666 9.33325C10.6666 10.7477 11.2285 12.1043 12.2287 13.1045C13.2289 14.1047 14.5854 14.6666 15.9999 14.6666Z",
    fill: "#4611A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7794_55726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.f171a6131ea9149ed95a2710c9189a3c.svg";
export { ForwardRef as ReactComponent };